import {
  GET_PRODUCTCATEGORY,
  GET_PRODUCTCATEGORY_SUCCESS,
  GET_PRODUCTCATEGORY_FAIL,
  DELETE_PRODUCTCATEGORY,
  DELETE_PRODUCTCATEGORY_SUCCESS,
  DELETE_PRODUCTCATEGORY_FAIL,
  UPDATE_PRODUCTCATEGORY,
  UPDATE_PRODUCTCATEGORY_SUCCESS,
  UPDATE_PRODUCTCATEGORY_FAIL,
  ADD_NEW_PRODUCTCATEGORY,
  ADD_PRODUCTCATEGORY_SUCCESS,
  ADD_PRODUCTCATEGORY_FAIL,
  PRODUCTCATEGORY_LOADING,
  PRODUCTCATEGORY_RESET
} from "./actionType";

export const resetProductCategoryState = (actionType) => ({
  type: PRODUCTCATEGORY_RESET,
  payload: { actionType },
});

export const getProductCategorySuccess = (actionType, data) => ({
  type: GET_PRODUCTCATEGORY_SUCCESS,
  payload: { actionType, data },
});

export const getProductCategoryFail = (actionType, error) => ({
  type: GET_PRODUCTCATEGORY_FAIL,
  payload: { actionType, error },
});

export const getProductCategory = data => ({
  type: GET_PRODUCTCATEGORY,
  payload: data,
});

export const getProductCategoryLoading = () => ({
  type: PRODUCTCATEGORY_LOADING
});

export const deleteProductCategory = data => ({
  type: DELETE_PRODUCTCATEGORY,
  payload: data,
});

export const deleteProductCategorySuccess = data => ({
  type: DELETE_PRODUCTCATEGORY_SUCCESS,
  payload: data,
});

export const deleteProductCategoryFail = error => ({
  type: DELETE_PRODUCTCATEGORY_FAIL,
  payload: error,
});

export const updateProductCategory = data => ({
  type: UPDATE_PRODUCTCATEGORY,
  payload: data,
});

export const updateProductCategoryFail = error => ({
  type: UPDATE_PRODUCTCATEGORY_FAIL,
  payload: error,
});

export const updateProductCategorySuccess = data => ({
  type: UPDATE_PRODUCTCATEGORY_SUCCESS,
  payload: data,
});

export const addNewProductCategory = data => ({
  type: ADD_NEW_PRODUCTCATEGORY,
  payload: data,
});

export const addProductCategorySuccess = data => ({
  type: ADD_PRODUCTCATEGORY_SUCCESS,
  payload: data,
});

export const addProductCategoryFail = error => ({
  type: ADD_PRODUCTCATEGORY_FAIL,
  payload: error,
});